import React from "react";
import { stackList } from "../../data/ProjectData";

import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";


function About() {

  return (
    <ContactWrapper id="about">
      <div className="Container">
        <div className="SectionTitle">About Me</div>
        <div className="BigCard">
          <Image
            src="https://avatars.githubusercontent.com/u/86410181?v=4"
            alt="man-svgrepo"
          />
          <div className="AboutBio">
          Hi everyone, I am <strong>Prajal Bankoti </strong>, I am from<strong> Nainital Uttarakhand </strong>.
        <br/>
        <br/>
        Aspiring full-stack web developer with a passion for working with product-based companies. A quick learner with the ability to devote complete time and focus to the task in hand. Looking forward to working in a challenging role while acquiring extensive development experience.
          </div>
          <div className="AboutBio tagline2">
            {/* I have become confident using the following technologies. */}
          </div>
          <Technologies>
            {stackList.map((stack, index) => (
              <Tech key={index} className="tech">
                <TechImg src={stack.img} alt={stack.name} />
                {/* <TechName>{stack.name}</TechName> */}
             
              </Tech>
            ))}
          </Technologies>
        </div>
      </div>
    </ContactWrapper>
  );
}

export default About;
